function withDefaultProps(Component, defaultProps) {
  return (props) => {
    const finalProps = { ...defaultProps };

    Object.keys(props).forEach((key) => {
      finalProps[key] = props[key] !== undefined ? props[key] : finalProps[key];
    });

    return <Component {...finalProps} />;
  };
}

export default withDefaultProps;
